module.exports = __webpack_public_path__ + "img/header-failed.9ab88370.png";